import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const bars = [
  { v: 64, l: "START", hot: true },
  { v: 52, l: "" },
  { v: 38, l: "" },
  { v: 22, l: "BREAK" },
  { v: 61, l: "RESET", hot: true },
  { v: 46, l: "" },
  { v: 31, l: "" },
  { v: 18, l: "BREAK" },
];

export const DecisionWindow = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });

  return (
    <div ref={ref} data-testid="science-decision-window">
      <p className="font-mono-brand text-[9px] sm:text-[10px] tracking-[0.24em] text-[#9DA1A8] mb-5">
        FAVOURABLE DECISIONS, ACROSS ONE WORKING DAY
      </p>
      <div className="grid grid-cols-8 gap-1.5 sm:gap-3 items-end">
        {bars.map((b, i) => (
          <div key={b.l + i} className="flex flex-col items-center">
            <span
              className="font-mono-brand text-[9px] sm:text-[10px] mb-2"
              style={{ color: b.hot ? "#FF4D0A" : "#6E7178" }}
            >
              {b.v}%
            </span>
            <div className="w-full h-28 sm:h-40 bg-[#F2F0EB]/[0.05] flex items-end">
              <motion.div
                className="w-full"
                style={{ background: b.hot ? "#FF4D0A" : "#2A2C30" }}
                initial={{ height: 0 }}
                animate={inView ? { height: `${b.v}%` } : { height: 0 }}
                transition={{ duration: 1, delay: 0.1 + i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              />
            </div>
            <span className="font-mono-brand text-[7px] sm:text-[8px] tracking-[0.12em] text-[#6E7178] mt-3 h-3">
              {b.l}
            </span>
          </div>
        ))}
      </div>
      <p className="font-mono-brand text-[10px] tracking-[0.2em] uppercase text-[#6E7178] mt-4">
        Stylised from Danziger et al., PNAS 2011.
      </p>
    </div>
  );
};
